import { Component, Input } from '@angular/core';
import { PlanDTO } from 'src/app/models/PlanDTO.model';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { PlanService } from 'src/app/services/plan.service';
import { AssignPlanService } from 'src/app/services/assign-plan.service';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { UserPlanDevDTO } from 'src/app/models/UserPlanDevDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { BillingService } from 'src/app/services/billing.service';
import { SimpleValueDecimal } from 'src/app/models/SimpleValueDecimal.model';
import { ResponseBase } from 'src/app/models/ResponseBase';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ValidateDecimalsDirective } from '../../../directives/validate-decimals.directive';
@Component({
    selector: 'app-assign-plan',
    templateUrl: './assign-plan.component.html',
    styleUrls: ['./assign-plan.component.css'],
    imports: [CommonModule, FormsModule, ValidateDecimalsDirective]
})
export class AssignPlanComponent {
  @Input() customerDataInput: any;
  information: string = 'Assign Plan';
  idCustomer?: number = undefined;
  planSelected?: number = 0;
  plans: PlanDTO[] = [];
  discount?: number = undefined;
  tipeDiscount: string = "";
  listTipeDiscount: MasterDataDTO[] = [];
  dateValidFrom?: Date = undefined;
  dateValidUntil?: Date = undefined;
  fieldsCompleted: boolean = false;
  isValidProrating: boolean = false;
  description: string = '';
  prorationInitial?: number = undefined;

  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 3,
  };
  userPlanDev: UserPlanDevDTO = {
    aPlanId: undefined,
    aDiscount: undefined,
    aTypeDiscount: '',
    aValidFrom: undefined,
    aValidUntil: undefined,
    aDescription: '',
    aDeviceId: undefined,
    aUserId: undefined,
    aUserPlanId: undefined,
    aStatus: undefined,
    aDateCreated: undefined,
    aDateModified: undefined,
  };

  alert: Alert = {} as Alert;


  constructor(
    private plansService: PlanService,
    private alertService: AlertService,
    private assignPlanService: AssignPlanService,
    private billingService: BillingService,
  ) { }

  ngOnInit() {
    this.idCustomer = this.customerDataInput.userId;
    this.plansService.getAllPlansAssignPlan().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllPlansAssignPlan(Data)
          : this.handleError(StatusCode),
      (error) => {
        this.clearFields();
      }
    );

    this.assignPlanService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetMastersById(Data)
          : this.handleError(StatusCode),
      (error) => {
        this.clearFields();
      }
    );
  }

  handleGetMastersById(data: MasterDataDTO[]) {
    this.listTipeDiscount = data;
  }

  handleGetAllPlansAssignPlan(data: PlanDTO[]) {
    this.plans = data;
  }

  handleError(statusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  clearFields() {
    this.planSelected = undefined;
    this.discount = undefined;
    this.tipeDiscount = '';
    this.dateValidFrom = undefined;
    this.dateValidUntil = undefined;
    this.description = '';
  }

  checkFields() {

    if (this.discount) {
      this.fieldsCompleted =
        this.planSelected != undefined &&
        this.tipeDiscount != ""
    }
    else {
      this.fieldsCompleted =
        this.planSelected != undefined;
      this.tipeDiscount = ""
    }

    if (this.tipeDiscount === '1' && this.discount !== undefined) {
      if (this.discount < 0 || this.discount > 100) {
        this.discount = undefined;
      }
    }

    if (!this.dateValidFrom) {
      this.fieldsCompleted = false;
    }

    if (this.dateValidFrom && this.dateValidUntil) {
      if (this.dateValidFrom >= this.dateValidUntil) {
        this.dateValidUntil = new Date(this.dateValidFrom);
        this.dateValidUntil.setDate(this.dateValidUntil.getDate() + 1);
      }
    }

    if (this.planSelected == 0) {
      this.fieldsCompleted = false;
    }

    if (!this.dateValidFrom) {
      this.fieldsCompleted = false;
    }

    this.prorationInitial = undefined;
  }

  minDate(): string | null {
    if (this.dateValidFrom) {
      const minDate = new Date(this.dateValidFrom);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().split('T')[0];
    }
    return null;
  }

  assignPlan() {
    this.userPlanDev.aPlanId = this.planSelected !== undefined ? parseInt(this.planSelected.toString()) : undefined;
    this.userPlanDev.aDiscount = this.discount != null ? parseFloat(this.discount.toString().replace(/[\$,]/g, '').replace(/\,/g, '.')) : undefined;
    this.userPlanDev.aTypeDiscount = this.tipeDiscount;
    this.userPlanDev.aValidFrom = this.dateValidFrom !== undefined ? new Date(this.dateValidFrom) : undefined;
    this.userPlanDev.aValidUntil = this.dateValidUntil !== undefined ? new Date(this.dateValidUntil) : undefined;
    this.userPlanDev.aDescription = this.description;
    this.userPlanDev.aDeviceId = undefined;
    this.userPlanDev.aUserId = this.idCustomer !== undefined ? parseInt(this.idCustomer.toString()) : undefined;
    this.userPlanDev.prorationInitial = this.prorationInitial;

    this.assignPlanService.assignPlan(this.userPlanDev).subscribe(
      (data) =>
        this.handleAssignPlanSuccess(data),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  calculateProration() {
    if (this.isFiledsValid()) {
      this.userPlanDev.aPlanId = this.planSelected !== undefined ? parseInt(this.planSelected.toString()) : undefined;
      this.userPlanDev.aDiscount = this.discount != null ? parseFloat(this.discount.toString().replace(/[\$,]/g, '').replace(/\,/g, '.')) : undefined;
      this.userPlanDev.aTypeDiscount = this.tipeDiscount;
      this.userPlanDev.aValidFrom = this.dateValidFrom !== undefined ? new Date(this.dateValidFrom) : undefined;
      this.userPlanDev.aValidUntil = this.dateValidUntil !== undefined ? new Date(this.dateValidUntil) : undefined;
      this.userPlanDev.aDescription = this.description;
      this.userPlanDev.aDeviceId = undefined;
      this.userPlanDev.aUserId = this.idCustomer !== undefined ? parseInt(this.idCustomer.toString()) : undefined;


      this.billingService.calculateProrationStart(this.userPlanDev).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleGetProratingStartSuccess(Data)
            : this.handleError(StatusCode),
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
          this.clearFields();
        }
      );
    }
  }

  // Método para verificar si la fecha está diligenciada y es válida
  isFiledsValid(): boolean {
    if (this.planSelected == 0 ||
      (this.dateValidFrom === undefined || String(this.dateValidFrom).trim() === '')) {
      this.isValidProrating = false;
    }
    else {
      this.isValidProrating = true;
    }
    //this.prorationInitial = 0;
    return this.isValidProrating;
  }

  async handleAssignPlanSuccess(data: ResponseBase) {

    if (data.validationErrorMessage) {
      this.alertService.error(data.validationErrorMessage);
      return;
    }

    this.alertService.success("Plan assigned successfully")
    location.reload();
  }

  async handleGetProratingStartSuccess(data: SimpleValueDecimal) {
    this.prorationInitial = data.value;
  }

  onInputChange() {
    this.prorationInitial = undefined;
  }
}